/**
 * Append the Strapi URL to the path
 */
export const strapiUrl = (path: string) => {
  if (path.startsWith("http")) {
    return path;
  }

  // Next inlines only NEXT_PUBLIC_* into the client bundle, so the STRAPI_URL fallback
  // resolves on the server and is undefined in the browser. A client component then
  // renders an absolute URL during SSR and a host-less path after hydration, which the
  // image optimizer rejects with a 400 - the "image flashes, then disappears" symptom.
  // Fail loudly outside production instead of silently shipping a relative path.
  const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL ?? process.env.STRAPI_URL;
  if (!baseUrl) {
    if (process.env.NODE_ENV !== "production") {
      throw new Error(
        "Missing Strapi base URL. Set NEXT_PUBLIC_STRAPI_URL in apps/web/.env.local and rebuild - " +
          "STRAPI_URL alone only works on the server.",
      );
    }

    return path;
  }

  return `${baseUrl}${path}`;
};

export const getStrapiUrl =
  process.env.NEXT_PUBLIC_STRAPI_URL ?? process.env.STRAPI_URL;
